﻿namespace Utilities

type RemoteCommand<'TError> =
    | NotSent
    | Sending
    | CommandFailed of 'TError